export const labelSorter = (a, b) => {
  const A = a.label.toLowerCase()
  const B = b.label.toLowerCase()
  return A < B ? -1 : A > B ? 1 : 0
}
